'use client';

import { loadStripe, Stripe } from '@stripe/stripe-js';
import React, { createContext, PropsWithChildren, useContext } from 'react';

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_API_KEY as string
);

const StripeLibContext = createContext<{ stripe: Promise<Stripe | null> }>({
  stripe: Promise.resolve(null),
});

export const useStripeLibContext = () => {
  const stripe = useContext(StripeLibContext);
  if (!stripe) {
    throw new Error('useStripe must be used within a StripeProvider');
  }
  return stripe;
};

export const StripeLibProvider = ({
  children,
}: PropsWithChildren<{ stripe?: Promise<Stripe | null> }>) => {
  return (
    <StripeLibContext.Provider value={{ stripe: stripePromise }}>
      {children}
    </StripeLibContext.Provider>
  );
};
